export const testimonials = [
  {
    id: 't-1',
    name: '张伟',
    title: '某大型地产集团 CIO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%20with%20warm%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%2C%20soft%20studio%20lighting%2C%20professional%20attire&width=100&height=100&seq=mjhl-avatar-1&orientation=squarish',
    content: '与 MJHL 合作三年来，我们的智能家居项目交付效率提升了 40%，客户满意度达到 98%。MJHL 的产品质量和技术支持都是一流的，是我们最信赖的合作伙伴。',
    rating: 5,
    product: '智能家居解决方案',
  },
  {
    id: 't-2',
    name: '李明华',
    title: '某金融机构技术总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20business%20portrait%20with%20confident%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot%2C%20soft%20studio%20lighting%2C%20modern%20professional%20attire&width=100&height=100&seq=mjhl-avatar-2&orientation=squarish',
    content: 'MJHL WorkFlow 和 DataCore 彻底改变了我们的办公方式。全集团 5000+ 员工统一协同办公，年度运维成本降低 60%，这在我们之前的方案中是无法想象的。',
    rating: 5,
    product: '企业协同平台 WorkFlow',
  },
  {
    id: 't-3',
    name: '王芳',
    title: '某重点中学校长',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20with%20warm%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20soft%20studio%20lighting%2C%20elegant%20attire&width=100&height=100&seq=mjhl-avatar-3&orientation=squarish',
    content: '引入 MJHL LearnPath 自适应学习系统后，我们学校的学生平均成绩提升了 18%，学困生转化率达到 70%。MJHL 的产品真正做到了因材施教，让每个孩子都能找到适合自己的学习节奏。',
    rating: 5,
    product: '自适应学习系统 LearnPath',
  },
  {
    id: 't-4',
    name: '陈志强',
    title: '个体用户 / 智能家居爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20with%20approachable%20smile%2C%20clean%20white%20background%2C%20modern%20headshot%2C%20soft%20studio%20lighting%2C%20casual%20professional%20look&width=100&height=100&seq=mjhl-avatar-4&orientation=squarish',
    content: '用了 MJHL 智能家居全家桶后，真的感受到科技改变生活。智能中枢的 AI 场景学习太智能了，自动识别我的作息习惯。SafeLock X 的安全感也是其他品牌给不了的。',
    rating: 5,
    product: 'MJHL 智能家居全家桶',
  },
  {
    id: 't-5',
    name: '刘敏',
    title: '某三甲医院健康管理科主任',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20doctor%20portrait%20with%20calm%20professional%20expression%2C%20clean%20white%20background%2C%20medical%20professional%20headshot%2C%20soft%20studio%20lighting%2C%20white%20coat&width=100&height=100&seq=mjhl-avatar-5&orientation=squarish',
    content: 'MJHL VitalBand Pro 的健康监测数据准确度令人印象深刻。我们科室将其用于患者的日常健康监测，数据与专业设备的一致性超过 95%，大大提高了慢病管理效率。',
    rating: 5,
    product: '健康手环 VitalBand Pro',
  },
  {
    id: 't-6',
    name: '赵鹏飞',
    title: '渠道合作伙伴 / 年营收增长 5 倍',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%20with%20confident%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%2C%20soft%20studio%20lighting%2C%20modern%20business%20attire&width=100&height=100&seq=mjhl-avatar-6&orientation=squarish',
    content: '成为 MJHL 合作伙伴是我做过最正确的商业决策。MJHL 不仅产品力强，对渠道的支持也非常到位。三年的合作，我们的年营收增长了 5 倍，团队规模也扩大了 3 倍。',
    rating: 5,
    product: 'MJHL 渠道合作',
  },
];